import { Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import { CaseService } from 'src/app/services/case.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { DictionaryService } from 'src/app/services/dictionary.service';
import { ScheduleService } from 'src/app/services/schedule.service';
import { MessageService, Message, ConfirmationService } from 'primeng/api';

import { ApplicationStatusDto } from 'src/app/application/case/dto/application-status.dto';
import * as theGlobals from 'src/app/shared/globals';

@Component({
  selector: 'app-case-status',
  templateUrl: './case-status.component.html'
})
export class CaseStatusComponent implements OnInit {

    @Input() caseId: string;
    @Input() userRole: string;
    @Output() changeEvent = new EventEmitter();

    statuses: any[];
    cols: any[];
    myStatus: any; // ApplicationStatusDto;
    isNewEntry: boolean = false;
    statusChoiceList: [];
    subStatusChoiceList: [];
    hearingDateList: any[];
    myDelStatusId: any; // case status to be deleted!

    displayState = {
        statusEntryDiv: false,
        saveDisabled: false,
        workingDiv: false
    };

    isLoading: boolean = false;

    allowNew: boolean = false;
    allowSave: boolean = false;
    allowDelete: boolean = false;
    allowOldHearings: boolean;

    constructor(private caseService: CaseService, private utilService: UtilitiesService, private dictService: DictionaryService,
        private messageService: MessageService, private confirmationService: ConfirmationService, private schedService: ScheduleService) { }

    ngOnInit() {
        this.setAllowFlags();
        this.cols = [
        { field: 'statusDate', header: 'Date' },
        { field: 'status', header: 'Status' },
        { field: 'subStatus', header: 'Sub-status' },
        { field: 'hearingDate', header: 'Hearing Dt' }
        ];
        this.allowOldHearings = theGlobals.allowOldHearings;
        this.isLoading=true;
        this.getStatusList();
        this.initLists();   // get dictionaries, etc

    }
    setAllowFlags() {
        if (this.userRole.includes('Clerk') || this.userRole.includes('Administrator')) {
            this.allowNew = true;
            this.allowSave = true;
            this.allowDelete = true;
        }
        else {
            this.allowNew = false;
            this.allowSave = false;
            this.allowDelete = false;
        }
    }

    newStatus() {
        // this.myStatus = new ApplicationStatusDto();
        this.myStatus = {
            id: 0,
            applicationId: Number(this.caseId),
            applicationIds: [],
            status: '',
            subStatus: '',
            hearingDate: null,
            hearingId: 0,
            statusDate: null,
        };
        this.utilService.doAudit(this.myStatus, 'creating a new status:');
        this.isNewEntry = true;
        this.displayState.statusEntryDiv = true;
    }

    selectStatus(item) {
        // this.myStatus = item;
        this.myStatus = {
            id: item.id,
            applicationId: Number(this.caseId),
            applicationIds: [],
            status: item.status,
            subStatus: item.subStatus,
            hearingDate: item.hearingDate,
            hearingId: item.hearingId,
            statusDate: new Date(item.statusDate),
        };
        // this.myStatus.statusDate = new Date(item.statusDate);
        this.utilService.doAudit(this.myStatus, 'editing a status:');
        this.isNewEntry = false;
        this.displayState.statusEntryDiv = true;
    }

    validateStatus() {
        if ((!this.myStatus.statusDate) || (!this.myStatus.status)) {
            return false;
        } else {
            return true;
        }
    }

    validateHearingDate() {
        this.utilService.doAudit(this.myStatus,'myStatus:');
        let hearingId = this.myStatus.hearingId;
        if ((!hearingId)) {
            return true;
        }
        let tHearing = this.hearingDateList.filter(t => {
            return t.id == hearingId ? t: null
        });
        if (tHearing.length < 1) {
            // could not find the matching Hearing Date in the list... should NOT happen!
            return false;
        }
        const tHearDt = new Date(tHearing[0].hearingDate);
        const tStatusDt = new Date(this.myStatus.statusDate);
        this.utilService.doAudit(tHearDt.getTime(), 'tHearDt:');
        this.utilService.doAudit(tStatusDt.getTime(), 'tStatusDt:');
        this.utilService.doAudit(tHearDt.getTime() < tStatusDt.getTime(),'eval:');
        if (tHearDt.getTime() < tStatusDt.getTime()) {
            return false;
        } else {
            return true;
        }
    }
    saveStatusEntry() {
        if (this.validateStatus() === false) {
            this.showToast({ key: 'toastStatus', severity: 'error', detail: 'Please enter a Status Date and Status', summary: 'Missing data' });
            return;
        } else if (this.validateHearingDate() === false) {
            this.showToast({ key: 'toastStatus', severity: 'error', detail: 'The Hearing Date must be LATER than the Status Date', summary: 'Invalid data' });
            return;
        }
        // save the new status, then refresh status list...
        this.utilService.doAudit(this.myStatus, 'saving status:');
        this.displayState.saveDisabled = true;
        this.displayState.workingDiv = true;
        //
        this.caseService.saveCaseStatus(this.myStatus).subscribe(data => {
            this.utilService.doAudit(data, 'response from saveCaseStatus:');
            this.showToast({ key: 'toastStatus', severity: 'info', detail: 'Case Status was saved!', summary: 'Info' });
            this.getStatusList();
            this.updateParentStatus();  // update parent/case status - rod 7/10/2025
            this.displayState.statusEntryDiv = false;
            this.displayState.saveDisabled = false;
            this.displayState.workingDiv = false;
            this.myStatus = {}; // clear out the status object, just in case...
        });
    }

    cancelStatusEntry() {
        this.displayState.statusEntryDiv = false;
    }

    deleteStatus(myStat: any) {
        this.utilService.doAudit(myStat, 'about to delete status:');
        this.myDelStatusId = myStat.id;
        if ( !this.myDelStatusId) {
            this.showToast({ key: 'toastStatus', severity: 'error', detail: 'Nothing done!', summary: 'Missing Case Status ID' });
            return;
        }
        this.confirmationService.confirm({
            message: 'Do you want to DELETE this Case Status?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            accept: () => {
                this.utilService.doAudit('hit onConfirm');
                this.caseService.deleteCaseStatus(this.myDelStatusId, this.caseId).subscribe(data => {
                    this.utilService.doAudit(data, 'returned from deleteCaseStatus:');
                    this.showToast({ key: 'toastStatus', severity: 'success', detail: 'Status Deleted', summary: 'Info' });
                    this.getStatusList();
                    this.cancelStatusEntry();
                    this.updateParentStatus();  // emit change to parent, to update case status (open/closed) - rod
                });
            },
            key: 'confirmStatus',
            reject: () => {
                //this.utilService.doAudit('hit onReject');
                this.showToast({ key: 'toastStatus', severity: 'info', detail: 'No action taken', summary: 'Info' });
            }
        });
        return true;
      }

    // get list of statuses assoc. w/ this case...
    getStatusList() {
      this.allowDelete = false;
        if (this.caseId) {
            this.caseService.getCaseStatusList(this.caseId).subscribe(data => {
                this.statuses = data;
                this.isLoading = false;
                this.allowDelete = data.length > 1; // do NOT allow deletion if there is only one status! - rod 12/25
            });
        }
    }
    updateParentStatus() {
      this.utilService.doAudit('updating parent status')
      this.changeEvent.emit();
    }

    // get data used to populated selects in template
    initLists() {
        const dicts = this.dictService.getDictionaries(); // get all dictionaries
        this.statusChoiceList = dicts.statusChoices;
        this.subStatusChoiceList = dicts.subStatusChoices;
        const baseDate = new Date();
        baseDate.setDate(baseDate.getDate() - 30); // subtract 1 day
        this.schedService.getHearingDates().subscribe(data => {
          this.utilService.doAudit(data, 'hearing dates:');
            if (data) {
                // filter to get only today + future dates...
                this.hearingDateList = data.filter(t => {
                  const tHearDt = new Date(t.hearingDate);
                  return tHearDt >= baseDate || this.allowOldHearings ? t : null;
                });
                // sort it in chronological order
                this.hearingDateList.sort((a, b) => {
                  // @ts-ignore
                  return new Date(a.hearingDate) - new Date(b.hearingDate);
                });
              const mapped = this.hearingDateList.map(item => ({
                ...item,
                // create new field based on the hearingDate (w/o time part) + hearingTime + boardNumber
                hearingDateDesc: `${item.hearingDate.split('T')[0]} ${item.hearingTime}`
              }));
              this.utilService.doAudit(mapped, 'mapped hearing list:');
              this.hearingDateList = mapped;
                this.hearingDateList.unshift({
                    id: 0,
                    hearingDate: null,
                    hearingTime: null,
                    hearingTimeDesc: null,
                }); // add blank at beginning (to allow "clearing" of previous selection)
                this.utilService.doAudit(this.hearingDateList, 'hearing dates:');
            }
        });
    }

    showToast(msg: Message) {
        this.messageService.clear();    // clear ALL messages/toasts
        this.messageService.add(msg);
    }

}
